module.exports = __webpack_public_path__ + "img/get-loan.95b589f0.svg";